<template>
  <div style="padding-left:5px;padding-right:5px;">
    <CompletedPairingDetailDialog
      :dialog="showCompletedPairingDetailDialog"
      :pairing="pairing"
      @close="closeCompletedPairingDetailDialog"
    >
    </CompletedPairingDetailDialog>

    <v-data-table
      class="mt-5"
      single-select
      :footer-props="{ disableItemsPerPage: true, }"
      :headers="headers"
      :loading="busy"
      :items="pairings"
      :items-per-page="10"
      :server-items-length="serverItemsLength"
      :options.sync="options"
    >
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" @click.stop="loadAndShowCompletedPairingDetailDialog(item)" v-on="on">zoom_in</v-icon>
          </template>
          <span>View Completed Pairing Details</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment';
import CompletedPairingDetailDialog from './CompletedPairingDetailDialog.vue';

export default {
  components: {
    CompletedPairingDetailDialog,
  },

  data() {
    return {
      headers: [
        {
          text: 'Vendor',
          align: 'left',
          sortable: true,
          value: 'vendor',
          width: 100,
        },
        {
          text: 'Vendor Key',
          align: 'left',
          sortable: false,
          value: 'vendorKey',
          width: 100,
        },
        {
          text: 'Alignment ID',
          align: 'left',
          sortable: false,
          value: 'alignmentId',
          width: 125,
        },
        {
          text: 'Tru-Point Serial Number',
          align: 'left',
          sortable: true,
          value: 'truPointSerialNumber',
          width: 225,
        },
        {
          text: 'Created At',
          align: 'left',
          sortable: true,
          value: 'createdAt',
          width: 250,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
        },
      ],
      options: {},
      pairings: [],
      busy: false,
      serverItemsLength: 0,
      showCompletedPairingDetailDialog: false,
      pairing: {},
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: `/read/completed_pairings/v1/?page=${this.options.page || 1}&sortBy=${this.options.sortBy || ''}&sortDesc=${this.options.sortDesc || false}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.pairings = res.data.docs.map((cur) => {
            const { createdAt, ...rest } = cur;
            return {
              createdAt: moment(createdAt).local().format('YYYY-MM-DD HH:mm:ss'),
              ...rest,
            };
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },
    loadAndShowCompletedPairingDetailDialog(completedPairing) {
      console.log(`completedPairing: ${JSON.stringify(completedPairing)}`);

      this.pairing = completedPairing;
      this.showCompletedPairingDetailDialog = true;
    },
    closeCompletedPairingDetailDialog() {
      this.showCompletedPairingDetailDialog = false;
      this.pairing = {};
    },
  },
};
</script>
